export const QuarterConstants = [
	{ from: '02.09', to: '31.10' },
	{ from: '01.11', to: '31.12' },
	{ from: '02.01', to: '31.03' },
	{ from: '01.04', to: '25.05' },
];
